import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { Profesion } from '../../models/profesion/profesion';

@Injectable({
  providedIn: 'root',
})
export class ProfesionesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.PROFESIONES}`;
  constructor(private http: HttpClient) {}

  getProfesiones(): Observable<Profesion[]> {
    return this.http.get<Profesion[]>(this.apiUrl);
  }
}
